import { defineComponent as _defineComponent } from 'vue'

import Icon from "@/components/widgets/icons/Icon.vue"
import { UploadFileInput } from "@/gql"
import { useUtilities } from "@/hooks/useUtilities"


export default /*#__PURE__*/_defineComponent({
  __name: 'FileAttachmentPreview',
  props: {
    file: null
  },
  emits: ["delete"],
  setup(__props: any) {




const { truncate } = useUtilities()

return { __sfc: true,truncate, Icon }
}

})